import { withInstall } from '@lit-element/utils'

import Image from './src/image.vue'
import type { SFCWithInstall } from '@lit-element/utils'

export const LtImage: SFCWithInstall<typeof Image> = withInstall(Image)
export default LtImage

export * from './src/image'
